import _ from "lodash";
import { Cellstyle, HotCellNumeric } from "~app/common/components/hot-doc/hotdoc/cell";

export class LagermalNumericStyledHotCell extends HotCellNumeric {
    constructor(value: number, private readonly cellClassList: string[], private readonly extraflags: Cellstyle, onChange: (newValue) => void) {
        super(value, extraflags, onChange);
    }

    static format(value: number): string {
        const val = _.isNumber(value) ? Math.round(value) : 0;
        return val !== 0 ? val.toLocaleString("en").replace(/,/g, " ") : "0";
    }

    applyCustomStyles(td: HTMLTableCellElement) {
        if (this.cellClassList) {
            td.classList.add(...this.cellClassList);
        }
    }

    validate(value: any): boolean {
        return _.isNumber(value) || !isNaN(value);
    }

    protected genHtml(): string {
        return LagermalNumericStyledHotCell.format(this.value);
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        this.applyCustomStyles(td);
        super.applyStyle(td, cellProperties);
    }
}
